<template>
  <div class="EditProject" v-if="project.address">
    <div class="boon-form-container">
      <div class="left-side">
        <fieldsContainer>
          <inputField
            class="half"
            :label="$t('Projektnummer / Project ref.')"
            :value="project.projectNumber"
            @input="updateSimpleProperty('projectNumber', $event)"
            :readonly="isReadonly"
          />
          <inputField
            class="half"
            :label="$t('Projektnamn / Project name')"
            :value="project.title"
            @input="updateSimpleProperty('title', $event)"
            :readonly="isReadonly"
          />
        </fieldsContainer>
        <fieldsContainer>
          <inputField
            id="street"
            class="half"
            :label="$t('Gatuadress / Street address')"
            :value="project.address.street"
            @input="updateAddressProperty('street', $event)"
            :readonly="isReadonly"
          />
          <inputField
            id="zipCode"
            class="half"
            :label="$t('Postnummer / Area code')"
            :value="project.address.zipCode"
            @input="updateAddressProperty('zipCode', $event)"
            :readonly="isReadonly"
          />
        </fieldsContainer>
        <fieldsContainer>
          <inputField
            id="city"
            class="half"
            :label="$t('Postort / City')"
            :value="project.address.city"
            @input="updateAddressProperty('city', $event)"
            :readonly="isReadonly"
          />
          <inputField
            id="country"
            class="half"
            :label="$t('Land / Country')"
            :value="project.address.country"
            @input="updateAddressProperty('country', $event)"
            :readonly="isReadonly"
          />
        </fieldsContainer>
        <fieldsContainer>
          <div class="boon-input-container full">
            <label>Fritext om projektet</label>
            <textarea
              class="boon-textarea"
              rows="3"
              @change="updateSimpleProperty('description', $event.target.value)"
              :value="project.description"
            />
          </div>
          <!-- <inputContainer :label="$t('Project Type')" :visibleLabel="Boolean(project.projectType)">
            <textarea class="free-text" name="" id="" cols="30" rows="10"></textarea>
          </inputContainer> -->
        </fieldsContainer>

        <fieldsContainer>
          <inputField
            id="projectBta"
            type="number"
            :label="$t('Project BTA')"
            :value="project.projectBta"
            :readonly="isReadonly"
            class="half"
            @input="updateSimpleProperty('projectBta', $event)"
          />
        </fieldsContainer>

        <div v-if="hasNoChildren" style="margin-top: 53px">
          <fieldsContainer>
            <inputContainer class="full">
              <b-labelled :title="$t('Project Template')" />
              <ul>
                <li>
                  <input
                    type="radio"
                    name="basedUpon"
                    id="basedUponEmpty"
                    value="empty"
                    checked
                    v-model="basedUponSelection"
                  />
                  <label for="basedUponEmpty">Empty</label>
                </li>
                <li>
                  <input
                    type="radio"
                    name="basedUpon"
                    id="basedUponStandard"
                    value="standard"
                    v-model="basedUponSelection"
                  />
                  <label for="basedUponStandard">Standard</label>
                </li>
              </ul>
            </inputContainer>
          </fieldsContainer>
          <fieldsContainer>
            <inputContainer class="full" style="justify-content: space-between; display: flex; align-items: center">
              <input type="radio" name="basedUpon" id="basedUponProject" value="project" v-model="basedUponSelection" />
              <multiselect
                class="boon-multiselect"
                :multiple="false"
                :options="projectList"
                :placeholder="$t('Choose a project to base the new one upon')"
                @input="basedUponSelection = 'project'"
                id="basedUpon"
                label="title"
                track-by="_id"
                v-model="basedUpon"
                style="width: 97%; display: inline-block"
              >
                <div slot="noResult">
                  {{ $t('No matching project found') }}
                </div>
              </multiselect>
            </inputContainer>
          </fieldsContainer>
        </div>
        <h1 class="text-title" :style="[!hasNoChildren ? { 'margin-top': '70px' } : '']">Organisation Projektering</h1>
        <ProjectUserList
          userList="projectManagers"
          :project="project"
          :users="project.projectManagers"
          :newOccupationList="newOccupationProjectManagers"
        />
        <h1 class="text-title" :style="[!hasNoChildren ? { 'margin-top': '70px' } : '']">
          {{ $t('Organisation Aftermarket') }}
        </h1>
        <ProjectUserList
          userList="aftermarkets"
          :project="project"
          :users="project.aftermarkets"
          :newOccupationList="newOoccupationAftermarkets"
        />
      </div>
      <div class="right-side">
        <fieldsContainer>
          <div class="boon-input-container half datepicker">
            <label>{{ $t('Projektstart / Project start') }}</label>
            <datepicker
              :format="customFormatter"
              :value="project.projectStartdate"
              @input="updateDate('projectStartdate', $event)"
              :readonly="isReadonly"
            ></datepicker>
          </div>
          <div class="boon-input-container half datepicker">
            <label>{{ $t('Projektavslut / Project end') }}</label>
            <datepicker
              :format="customFormatter"
              :value="project.projectEnddate"
              @input="updateDate('projectEnddate', $event)"
              :readonly="isReadonly"
            ></datepicker>
          </div>
        </fieldsContainer>
        <fieldsContainer>
          <div class="boon-input-container half datepicker">
            <label>{{ $t('Dagbok start / Diary start') }}</label>
            <datepicker
              :format="customFormatter"
              :value="diaryStartDate"
              @input="updateDate('diaryStartDate', $event)"
              :readonly="isReadonly"
            ></datepicker>
          </div>
        </fieldsContainer>
        <fieldsContainer>
          <ul class="dropDown-list">
            <li style="padding-top: 0">
              <DropDownList
                :index="0"
                :title="$t('Project Icon')"
                :property="'projectIcon'"
                :value="projectIcon"
                :isDropDownListIndex="dropDownListIndex"
                @toggleDropDown="toggleDropDown"
                @UpdateDropDownInput="UpdateDropDownInput"
              ></DropDownList>
            </li>
            <li>
              <DropDownList
                :index="1"
                :title="$t('Work Environment Plan')"
                :property="'workEnvironmentPlan'"
                :value="workEnvironmentPlan"
                :isDropDownListIndex="dropDownListIndex"
                @toggleDropDown="toggleDropDown"
                @UpdateDropDownInput="UpdateDropDownInput"
              ></DropDownList>
            </li>
            <li>
              <DropDownList
                :index="2"
                :title="$t('Self-Inspection')"
                :property="'selfMonitoring'"
                :value="selfMonitoring"
                :isDropDownListIndex="dropDownListIndex"
                @toggleDropDown="toggleDropDown"
                @UpdateDropDownInput="UpdateDropDownInput"
              ></DropDownList>
            </li>
            <li>
              <DropDownList
                :index="3"
                :title="$t('Project Description')"
                :property="'projectDescription'"
                :value="projectDescription"
                :isDropDownListIndex="dropDownListIndex"
                @toggleDropDown="toggleDropDown"
                @UpdateDropDownInput="UpdateDropDownInput"
              ></DropDownList>
            </li>
            <li>
              <DropDownList
                :index="4"
                :title="$t('Quality Document')"
                :property="'qualityDocument'"
                :value="qualityDocument"
                :isDropDownListIndex="dropDownListIndex"
                @toggleDropDown="toggleDropDown"
                @UpdateDropDownInput="UpdateDropDownInput"
              ></DropDownList>
            </li>
            <li>
              <DropDownList
                :index="5"
                :title="$t('Environmental Plan')"
                :property="'environmentalPlan'"
                :value="environmentalPlan"
                :isDropDownListIndex="dropDownListIndex"
                @toggleDropDown="toggleDropDown"
                @UpdateDropDownInput="UpdateDropDownInput"
              ></DropDownList>
            </li>
          </ul>
        </fieldsContainer>
        <h1 class="text-title">Organisation Produktion</h1>
        <ProjectUserList
          userList="projectSubcontractors"
          :project="project"
          :users="project.projectSubcontractors"
          :newOccupationList="newOoccupationProjectSubcontractors"
        />
      </div>
    </div>
    <div class="close-button" @click="close">{{ $t(this.closeText()) }}</div>
  </div>
</template>

<script>
import { EventBus } from '@/common/eventbus';
import { mapActions, mapGetters } from 'vuex';
import inputField from '@/components/form/inputField';
import fieldsContainer from '@/components/form/fieldsContainer';
import inputContainer from '@/components/form/inputContainer';
import BLabelled from '@/components/toolbar/BLabelled';
import Toggler from '@/components/toolbar/Toggler';
import Multiselect from 'vue-multiselect';
import ProjectUserList from './ProjectUserList';

import Datepicker from 'vuejs-datepicker';
import occupationJson from '../../occupation.json';
import moment from 'moment';
import DropDownList from './DropDownList';

export default {
  name: 'EditProject',
  metaInfo() {
    return {
      title: this.$t('Project Setup'),
    };
  },
  data() {
    return {
      basedUpon: {},
      basedUponSelection: 'empty',
      project: {},
      selectedDevelopingCompany: {},
      dropDownInput: false,
      dropDownListIndex: -1,
      projectIcon: '',
      workEnvironmentPlan: '',
      selfMonitoring: '',
      projectDescription: '',
      qualityDocument: '',
      environmentalPlan: '',
      dateFormat: 'yyyy-MM-dd',
      newOccupationProjectManagers: '',
      newOoccupationProjectSubcontractors: '',
      newOoccupationAftermarkets: '',
      selectedIndex: -1,
      diaryStartDate: moment().format('YYYY-MM-DD'),
    };
  },
  methods: {
    ...mapActions(['copyChildren', 'getStandardProject', 'loadProject', 'saveProjectProperties']),
    close: function () {
      if (!this.project._id) {
        this.$router.push({ name: 'ProjectList' });
        return;
      }
      if (this.basedUponSelection === 'project' && !this.basedUpon._id) {
        EventBus.$emit('showMessageToUser', {
          message: this.$t(
            'You have selected to copy stages and parts from another project, but not selected a project'
          ),
          type: 'error',
          duration: 3000,
        });
        return;
      }
      if (this.hasNoChildren && this.basedUponSelection !== 'empty') {
        var sourceId = this.basedUponSelection === 'standard' ? 'standard' : this.basedUpon._id;
        this.copyChildren({ fromProjectId: sourceId, toProjectId: this.project._id });
      }
      this.$router.go(-1);
      // this.$router.push({name: 'ProjectOverview', params: { _id: this.project._id }});
    },
    updateSimpleProperty: function (property, newValue) {
      // console.log(property, newValue);
      if (this.project[property] !== newValue) {
        var newProjectProperties = {};
        newProjectProperties[property] = newValue;
        this.saveProjectProperties({ updateProject: this.project, newProjectProperties: newProjectProperties }).then(
          (savedProject) => {
            this.project = savedProject;
          }
        );
      }
    },
    updateLink: function (property, newValue) {
      if (this.project.links[property] !== newValue) {
        var newProjectProperties = { links: Object.assign({}, this.project.links) };
        newProjectProperties.links[property] = newValue;
        this.saveProjectProperties({ updateProject: this.project, newProjectProperties: newProjectProperties });
      }
    },
    updateAddressProperty: function (property, newValue) {
      // console.log(property, newValue);
      if (this.project.address[property] !== newValue) {
        var newProjectProperties = { address: Object.assign({}, this.project.address) };
        newProjectProperties.address[property] = newValue;
        this.saveProjectProperties({ updateProject: this.project, newProjectProperties: newProjectProperties });
      }
    },
    closeText: function () {
      if (!this.project._id) {
        return 'Cancel';
      }
      if (this.hasNoChildren && this.basedUponSelection !== 'empty') {
        return 'Create Project';
      }
      return 'Close';
    },
    /**
     * toggle Drop Down.
     */
    toggleDropDown: function ({ index }) {
      if (this.dropDownListIndex === index) {
        this.dropDownListIndex = -1;
      } else {
        this.dropDownListIndex = index;
      }
    },
    /**
     * update Drop Down Input value
     * @param index, value, property
     */
    UpdateDropDownInput: function ({ index, value, property }) {
      // console.log(index, value, property);
      if (index > 0) {
        this.updateLink(property, value);
      } else {
        this.updateSimpleProperty(property, value);
      }
      setTimeout(() => {
        this.dropDownListIndex = -1;
      }, 300);
    },
    /**
     * update Diary StartDate.
     */
    updateDate: function (property, $event) {
      // console.log(property, moment($event).format('YYYY-MM-DD'));
      let value = moment($event).format('YYYY-MM-DD');
      this.updateSimpleProperty(property, value);
    },
    customFormatter: function (date) {
      return moment(date).format('YYYY-MM-DD');
    },
    sortOccupations: function (list) {
      list.sort((a, b) => {
        var at = a.occupation.toUpperCase();
        var bt = b.occupation.toUpperCase();
        if (this.$i18n.locale() === 'sv') {
          at = this.$t(a.occupation);
          bt = this.$t(b.occupation);
        }
        if (at < bt) {
          return -1;
        } else if (at > bt) {
          return 1;
        }
        if (a._id < b._id) {
          return -1;
        }
        return 1;
      });
      return list;
    },
  },
  computed: {
    ...mapGetters(['getCompany', 'hasSimplePermissions', 'projectList']),

    hasNoChildren() {
      return this.project.children.length === 0;
    },

    isReadonly() {
      return !this.hasSimplePermissions('saveProjectProperties');
    },
  },
  components: {
    BLabelled,
    Datepicker,
    inputContainer,
    inputField,
    fieldsContainer,
    Multiselect,
    Toggler,
    ProjectUserList,
    DropDownList,
  },
  mounted: async function () {
    if (this.$route.params._id) {
      this.project = await this.loadProject(this.$route.params._id);
      if (this.project.developingCompanyId) {
        this.selectedDevelopingCompany = this.getCompany(this.project.developingCompanyId);
      }
    } else {
      this.project = await this.getStandardProject();
    }
    if (this.project) {
      // set project link
      this.projectIcon = this.project.projectIcon;
      this.workEnvironmentPlan = this.project.links.workEnvironmentPlan;
      this.selfMonitoring = this.project.links.selfMonitoring;
      this.projectDescription = this.project.links.projectDescription;
      this.qualityDocument = this.project.links.qualityDocument;
      this.environmentalPlan = this.project.links.environmentalPlan;
    }
    if (this.project.diaryStartDate) {
      this.diaryStartDate = this.project.diaryStartDate;
    }

    this.newOccupationProjectManagers = this.sortOccupations(occupationJson.projectManagers);

    this.newOoccupationProjectSubcontractors = this.sortOccupations(occupationJson.projectSubcontractors);

    this.newOoccupationAftermarkets = this.sortOccupations(occupationJson.aftermarket);
  },
  watch: {
    $route: async function (to, from) {
      console.log('EditProject::watch:'); // , JSON.stringify(from), JSON.stringify(to));
      if (this.$route.params._id) {
        if (this.$route.params._id !== this.project._id) {
          this.project = await this.loadProject(this.$route.params._id);
          if (this.project.developingCompanyId) {
            this.selectedDevelopingCompany = this.getCompany(this.project.developingCompanyId);
          }
        }
      } else {
        this.project = await this.getStandardProject();
      }
    },
  },
};
</script>

<style scoped>
@font-face {
  /* font-family: 'DIN Alternate Bold'; */
  /* font-style: normal; */
  /* font-weight: normal; */
  /* src: local('DIN Alternate Bold'), url('/static/fonts/DINAlternate-Bold.woff') format('woff'); */

  font-family: 'DIN Alternate Bold';
  /* src: url('location.eot'); */
  src:
        /* url('location.eot#iefix') format('embedded-opentype'), */ url('/static/fonts/DINAlternate-Bold.woff')
      format('woff'),
    url('/static/fonts/DINAlternate-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'DIN-Light';
  src: url('/static/fonts/DINLight.woff') format('woff'); /* Modern Browsers */
  font-weight: normal;
  font-style: normal;
}
.EditProject {
  /* background: rgb(10,29,46); */
  /* background: linear-gradient(90deg, rgba(10,29,46,1) 0%, rgba(10,29,46,1) 70%, rgba(32,53,72,1) 100%); */
  color: #fff;
  padding: 20px;
}

.close-button {
  width: auto;
  background: #1c2731;
  color: white;
  padding: 20px 10px;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
}

.close-button:disabled {
  background-color: #abb1ba;
  color: #e2e2e2;
  cursor: default;
}

.Expander {
  display: flex;
  justify-content: center;
}

ul {
  list-style-type: none;
}

li {
  padding: 5px 0;
}
.EditProject .boon-form-container {
  display: flex;
  flex-direction: row;
}
.EditProject .left-side,
.EditProject .right-side {
  width: 50%;
}
.EditProject .boon-input-container {
  margin-bottom: 20px;
}
.EditProject .boon-input-container.full {
  width: calc(100% - 28px);
}
.EditProject .boon-textarea {
  background: transparent;
  border: 1px solid #bbb6bb55 !important;
  border-radius: 5px;
  padding: 7px 5px !important;
  font-size: 26px;
  font-family: 'DIN Alternate Bold';
  width: 100%;
  color: #fff;
}
.EditProject label {
  top: -20px !important;
  font-size: 14px !important;
  color: #fff;
  font-family: 'DIN-Light';
}
.EditProject ul.dropDown-list {
  margin-left: 15px;
  width: 100%;
}
.EditProject .dropDown-list li {
  font-size: 22px;
  font-weight: 500;
  width: 100%;
  padding: 10px 0;
}
.EditProject .left-side .text-title,
.EditProject .right-side .text-title {
  margin-bottom: 30px;
  padding-left: 13px;
  margin-top: 17px;
  font-family: 'DIN Alternate Bold';
  font-size: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/project/EditProject.vue